import { firestore } from "firebase/app";
import { toastr } from "react-redux-toastr";
import { reset } from "redux-form";
import { closeModal } from "../../../common/modals/modalActions";
import { createNewComplaint } from "../../../common/util/helper";
import {
  uploadAttachments,
  uploadFile,
} from "../../FileUpload/fileUploadActions";
import { updateProfile } from "../UpdateProfile/profileActions";
import { calculateAgeFromNRIC, getAgeGroup } from "../../../common/util/getAgeFromIC";
const { serverTimestamp } = firestore.FieldValue;

export const createComplaint = (payload) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    const user = getState().firebase.profile;
    const photoURL = getState().firebase.profile.photoURL;
    const { files, ...complaint } = payload;
    const id = complaint.id;

    let today = new Date();

    complaint.date = {
      year: today.getUTCFullYear(),
      month: today.getUTCMonth(),
      date: today.getUTCDate(),
    };
    complaint.lastEdited = {
      name: complaint.userFullName,
      uid: user.uid,
      role: user.role,
      date: serverTimestamp(),
    };

    user.displayName = complaint.userFullName;
    user.userFullName = complaint.userFullName;


    let age = calculateAgeFromNRIC(user.userNationalId)

    const ageGroup = getAgeGroup(age);

    complaint.age = age;
    complaint.ageGroup = ageGroup;
    const newComplaint = createNewComplaint(user, photoURL, complaint);

    try {
      await firestore
        .set(`complaints/${id}`, newComplaint)
        .then(() => {})
        .catch((error) => {
          console.error(error);
        });

      user.lastComplaintSent = serverTimestamp();

      dispatch(updateProfile(user));

      if (files && files.length > 0) {
        //console.log('has files');
        files.forEach((file) => {
          dispatch(uploadFile(file, file.name, complaint.id));
        });
      }

      toastr.success("Success!", "Complaint has been added");
      dispatch(closeModal());
    } catch (error) {
      console.error(error);
      toastr.error(
        "Add Complaint Error",
        "Complaint was not addedd. " + error.message
      );
    }
  };
};

export const updateComplaint = (payload) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const user = getState().firebase.profile;
    const { files, ...complaint } = payload;
    console.log("UPDATE_COMPLAINT: " + complaint);
    //console.log(files);
    complaint.lastEdited = {
      name: user.userFullName || user.displayName,
      uid: user.uid,
      role: user.role,
      date: serverTimestamp(),
    };

    if (
      complaint.status === "open" &&
      (user.role === "agent" || user.role === "manager")
    ) {
      complaint.status = "processing";
    }

    if (complaint !== "") {
      try {
        await firestore
          .update(`complaints/${complaint.id}`, complaint)
          .then(async () => {
            toastr.success(
              "Complaint update success",
              "Complaint was  updated."
            );
          })
          .catch((error) => {
            console.error(error);
          });
        if (files && files.length > 0) {
          dispatch(uploadFile(files[0], files[0].name, complaint.id));
        }
      } catch (error) {
        console.error(error);
        toastr.error(
          "Add Complaint Error",
          "Complaint was not addedd. " + error.message
        );
      }
    }
  };
};

export const updateComplaintArray = (complaintId, element, value, type) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    if (type === "remove") {
      try {
        await firestore
          .collection("complaints")
          .doc(complaintId)
          .update({ [element]: firestore.FieldValue.arrayRemove(value) })
          .then(() => {
            // console.log('success');
          })
          .catch((err) => console.error(err));
        toastr.success("Success");
      } catch (error) {
        toastr.error("Error", error);
      }
    }

    if (type === "add") {
      try {
        await firestore
          .collection("complaints")
          .doc(complaintId)
          .update({ [element]: firestore.FieldValue.arrayUnion(value) })
          .then(() => {
            // console.log('success');
          })
          .catch((err) => console.error(err));
        toastr.success("Success");
      } catch (error) {
        toastr.error("Error", error);
      }
    }
  };
};

export const cancelToggle =
  (cancelled, complaintId) =>
  async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    const message = cancelled
      ? "Are you sure you want to cancel this complaint?"
      : "This will reactivate the complaint, Are you sure?";

    try {
      toastr.confirm(message, {
        onOk: async () => {
          await firestore.update(`complaints/${complaintId}`, {
            cancelled: cancelled,
            status: "cancelled",
            lastEdited: {
              name: getState().firebase.profile.displayName,
              uid: getState().firebase.profile.uid,
              role: getState().firebase.profile.role,
              date: serverTimestamp(),
            },
          });
          toastr.success("Success", "You have cancelled this complaint");
        },
      });
    } catch (error) {
      //console.log(error);
      toastr.error("Error", "Update failed.");
    }
  };

export const sendEmail =
  (payload) =>
  async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firebase = getFirebase();
    const user = getState().firebase.profile;
    console.log(payload);

    let newPayload = { ...payload };
    newPayload.sender = user.displayName;
    newPayload.date = new Date().toISOString();
    newPayload.from = "NCCC <complaints@complaints.nccc.org.my>";
    newPayload.sender_id = user.uid;
    newPayload.received_from = "user";

    if (payload.files && payload.files.length > 0) {
      newPayload.hasAttachments = true;
    } else {
      newPayload.hasAttachments = false;
    }

    if (
      payload.status === "open" &&
      (user.role === "agent" || user.role === "manager")
    ) {
      newPayload.status = "processing";
    }

    try {
      // firestore
      // 	.set(`complaints/${payload.id}`, { status: 'processing' }, { merge: true })
      // 	.then(() => console.log('complaint status updated'))
      // 	.catch((error) => console.error('complaint status not updated. ' + error));

      //newPayload.date = TIMESTAMP;

      await firebase
        .push(`emails/${newPayload.id}`, newPayload)
        .then((data) => {
          console.log(data);
          if (payload.files && payload.files.length > 0) {
            //console.log('has files');
            payload.files.forEach((file, index) => {
              dispatch(
                uploadAttachments(
                  file,
                  file.name,
                  payload.id,
                  data.key,
                  index,
                  payload.files.length,
                  user.role === "complaintant"
                    ? `${payload.id}/attachments`
                    : `${payload.id}/documents`
                )
              );
            });
          }
          dispatch(reset("emailComplaint"));
          toastr.success("Success", "Email sent");
        })
        .catch((error) => {
          console.error(error);
          toastr.error("Failed", "Email failed");
        });
    } catch (error) {
      console.error(error);
      toastr.error("Failed", "Email failed");
    }
  };

export const updateSector =
  (complaint, payload) =>
  async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    //const { TIMESTAMP } = firebase.database.ServerValue;
    const user = getState().firebase.profile;
    const lastEdited = {
      name: user.displayName,
      uid: user.uid,
      role: user.role,
      date: serverTimestamp(),
    };

    if (payload !== "") {
      try {
        await firestore
          .collection("complaints")
          .doc(complaint.id)
          .update({
            lastEdited,
            sectors: firebase.firestore.FieldValue.arrayUnion(payload.sector),
            categories: firebase.firestore.FieldValue.arrayUnion(
              payload.category
            ),
            subcategories: firebase.firestore.FieldValue.arrayUnion(
              payload.subcategory
            ),
          })
          .then(() => console.log("sector updated"))
          .catch((error) => console.error("sector was not updated", error));
        //dispatch(updateComplaint(complaint));
        toastr.success("Success", "Sector Updated");
      } catch (error) {
        //console.log('sector not updated', error);
        toastr.error("Failed", "Sector was not updated");
      }
    }
  };

export const addAgent =
  (complaint, agent) =>
  async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const user = getState().firebase.profile;

    const lastEdited = {
      name: user.displayName,
      uid: user.uid,
      role: user.role,
      date: serverTimestamp(),
    };
    if (agent.uid !== "" || agent.uid !== null) {
      try {
        await firestore
          .collection("complaints")
          .doc(complaint.id)
          .update({
            lastEdited,
            agent,
            status: "processing",
          })
          .then(() => console.log("Agent has been assigned"))
          .catch((error) =>
            console.error("Agent has not been assigned", error)
          );
        //dispatch(updateComplaint(complaint));
        toastr.success("Success", "Agent has been assigned");
      } catch (error) {
        //console.log('sector not updated', error);
        toastr.error("Failed", "Agent has not been assigned" + error);
      }
    }
  };
